import { esIncluido } from "../../../utilities/valorEsIncluido.js";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

/**
 * Regla de negocio: dentro de la cotización solo se elimina la asociación del
 * catálogo para subproductos tipo "Adicional". Los Incluido mantienen su
 * asociación (solo se desasocian desde el mantenedor de productos).
 * Fuente de verdad: `tipo` (detalle_cotizacion no persiste `incluido`;
 * las filas en sesión lo setean consistente con tipo en construirNuevoSubproducto).
 */
export const esSubproductoAdicional = (item) =>
  item?.relacion === "subproducto" &&
  item?.tipo !== "Incluido" &&
  !esIncluido(item?.incluido);

/**
 * Subproducto tipo "Incluido": su asociación de catálogo no se elimina desde
 * la cotización (botón de borrado deshabilitado; desasociación solo desde el
 * mantenedor).
 */
export const esSubproductoIncluido = (item) =>
  item?.relacion === "subproducto" &&
  (item?.tipo === "Incluido" || esIncluido(item?.incluido));

/**
 * Desasocia del catálogo (producto_subproducto) los subproductos Adicionales
 * presentes en las filas indicadas (borrado directo o cascada). Fail-fast:
 * el primer error se propaga para que el flujo llamador aborte completo.
 * @param {string} baseUrl - URL base del backend.
 * @param {Array} filas - Filas a evaluar (itemsToDelete).
 * @param {Array} filasArriendo - Filas de arriendo para resolver el producto
 *   ancla si la fila no trae id_elemento_producto (fallback por descripción).
 * @return {number} Cantidad de asociaciones eliminadas.
 */
export const desasociarSubproductosAdicionales = async (
  baseUrl,
  filas,
  filasArriendo = []
) => {
  const productosMap = {};
  filasArriendo.forEach((d) => {
    if (d?.relacion === "producto") {
      productosMap[d.descripcion] = d;
    }
  });

  const vistas = new Set();
  const asociaciones = [];
  (filas || []).forEach((fila) => {
    if (!esSubproductoAdicional(fila)) return;

    let idProducto = fila.id_elemento_producto;
    if (idProducto == null) {
      const sufijoProducto = String(fila.descripcion ?? "").split(" - ")[1];
      idProducto = sufijoProducto ? productosMap[sufijoProducto]?.id_elemento : null;
    }

    if (idProducto == null || fila.id_elemento == null) return;

    const clave = `${idProducto}|${fila.id_elemento}`;
    if (vistas.has(clave)) return;
    vistas.add(clave);

    asociaciones.push({ idProducto, idSubproducto: fila.id_elemento });
  });

  for (const { idProducto, idSubproducto } of asociaciones) {
    await productService.deleteProductoSubproductoEntidad(baseUrl, {
      idProducto,
      idSubproducto,
    });
  }

  return asociaciones.length;
};